<h6 mat-dialog-title>
    {{ 'gedScanner' | translate }}
</h6>

<mat-dialog-content class="ged-scanner-dialog">

    <!-- Scanner GED -->
    <mat-form-field *ngIf="gedScanners.length > 1"
                    appearance="outline"
                    class="scanner-field">
        <mat-label>{{ 'gedScanner' | translate }}</mat-label>
        <mat-select [(ngModel)]="scannerCur"
                    (selectionChange)="loadScannerDevices()">
            <mat-option *ngFor="let scanner of gedScanners"
                        [value]="scanner">
                {{ scanner.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Scanner physique -->
    <mat-form-field *ngIf="scannerDevices.length > 1"
                    appearance="outline"
                    class="scanner-field">
        <mat-label>Scanner physique</mat-label>
        <mat-select [(ngModel)]="scannerDeviceCur">
            <mat-option *ngFor="let scanner of scannerDevices"
                        [value]="scanner">
                {{ scanner.name }}
                <span *ngIf="scanner.manufacturer">
                    - {{ scanner.manufacturer }}
                </span>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Scanner sélectionné -->
    <div *ngIf="scannerDeviceCur"
         class="scanner-selected">
        <mat-icon>scanner</mat-icon>
        <span>
            {{ scannerDeviceCur.name }}
            <span *ngIf="scannerDeviceCur.manufacturer">
                - {{ scannerDeviceCur.manufacturer }}
            </span>
        </span>
    </div>

    <!-- Aucun scanner disponible -->
    <div *ngIf="scannerCur && scannerDevices.length === 0"
         class="scanner-warning">
        {{ 'noGedScannerAvailable' | translate }}
    </div>

    <!-- État du scanner -->
    <div class="scan-progress"
         [class.scan-progress-active]="scanning || saving || cancelling"
         [class.scan-progress-waiting]="!scanning &&
                                          !saving &&
                                          !cancelling &&
                                          scans.length < 10"
         [class.scan-progress-limit]="!scanning &&
                                        !saving &&
                                        !cancelling &&
                                        scans.length >= 10">

        <mat-icon class="scan-progress-icon">
            {{ cancelling
                ? 'delete_sweep'
                : scanning || saving
                    ? 'scanner'
                    : scans.length >= 10
                        ? 'block'
                        : 'scanner' }}
        </mat-icon>

        <div>
            <!-- État courant -->
            <div class="scan-progress-title">
                {{ cancelling
                    ? 'Annulation de la session en cours…'
                    : scanning
                        ? 'Numérisation en cours…'
                        : saving
                            ? 'Sauvegarde du document en cours…'
                            : scans.length >= 10
                                ? 'Limite de documents atteinte'
                                : 'Scanner en attente' }}
            </div>

            <!-- Explication de l'état courant -->
            <div class="scan-progress-text">
                {{
                    cancelling
                        ? ('scanWaiting_1' | translate)
                        : scanning
                            ? ('scanWaiting_2' | translate)
                            : saving
                                ? ('scanWaiting_3' | translate)
                                : scans.length >= 10
                                    ? ('scanWaiting_4' | translate)
                                    : ('scanWaiting_5' | translate)
                }}
            </div>
        </div>
    </div>

    <!-- Erreur -->
    <div *ngIf="scanError"
         class="scan-error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ scanError }}</span>
    </div>

    <!-- Confirmation d'annulation de la session -->
    <div *ngIf="confirmCancel"
         class="ged-cancel-confirm">

        <mat-icon>warning</mat-icon>

        <div class="ged-cancel-confirm-content">

            <div class="ged-cancel-confirm-title">
                {{ 'cancelSession' | translate }}
            </div>

            <div class="ged-cancel-confirm-text">
                {{'deleteSession' | translate: [scans.length]}}
            </div>

        </div>

        <!-- Confirmation -->
        <button mat-raised-button
                type="button"
                (click)="confirmCancelSession()">
            Oui, annuler
        </button>

        <!-- Retour à la session -->
        <button mat-button
                type="button"
                (click)="cancelCancelConfirmation()">
            Non
        </button>

    </div>

    <!-- Liste des documents numérisés -->
    <mat-card *ngIf="scans.length > 0"
              class="scan-card">

        <mat-card-content>

            <div *ngFor="let scan of scans; let i = index"
                 class="scan-item">

                <!-- Numéro dans la séquence -->
                <span class="scan-number">
                    {{ i + 1 }}
                </span>

                <!-- Nom du fichier -->
                <span class="scan-filename">
                    {{ scan.filename }}
                </span>

                <!-- État d'enregistrement -->
                <span class="scan-status">
                    <mat-icon>check_circle</mat-icon>
                    {{'registeredScan' | translate}}
                    Enregistré
                </span>

            </div>

        </mat-card-content>
    </mat-card>

    <!-- Aucun document numérisé -->
    <div *ngIf="scans.length === 0"
         class="scan-empty">

        <mat-icon>document_scanner</mat-icon>

        <div>

            <div class="scan-empty-title">
                {{'noDocScanned' | translate}}
            </div>

            <div class="scan-empty-text">
                {{'placeDocScanner' | translate}}
            </div>

        </div>

    </div>

</mat-dialog-content>

<!-- Boutons d'action -->
<mat-dialog-actions align="center"
                    class="ged-scanner-actions">

    <!-- Numériser le prochain document -->
    <button mat-raised-button
            type="button"
            [disabled]="!scannerDeviceCur ||
                        scanning ||
                        saving ||
                        cancelling ||
                        confirmCancel ||
                        scans.length >= 10"
            (click)="startScan()">

        <mat-icon>scanner</mat-icon>
        {{ 'startScanner' | translate }}

    </button>

    <!-- Terminer la séquence de numérisation -->
    <button mat-raised-button
            type="button"
            [disabled]="scanning ||
                        saving ||
                        cancelling ||
                        confirmCancel ||
                        scans.length === 0"
            (click)="validate()">

        <mat-icon>check</mat-icon>
            {{ 'completedScanner' | translate }}
    </button>

    <!-- Annuler la session -->
    <button mat-raised-button
            type="button"
            [disabled]="scanning ||
                        saving ||
                        cancelling ||
                        confirmCancel"
            (click)="cancel()">
        {{ 'cancelScanner' | translate }}
    </button>

</mat-dialog-actions>